export default __webpack_public_path__ + "static/media/user.1040c5f1.png";